import { UnknownError, NetworkError, ConnectionAbortedError, TimeoutError, InvalidSdkConfigurationError, InvalidRegionOrHostError, InvalidRegionError, InvalidHostError } from "@smash-sdk/core";
import { GenericError as ListPublicServicesGenericError } from "./types/ListPublicServices/ListPublicServicesError";
import { InternalServerError as ListPublicServicesInternalServerError } from "./types/ListPublicServices/ListPublicServicesError";
import { BadGatewayError as ListPublicServicesBadGatewayError } from "./types/ListPublicServices/ListPublicServicesError";
import { GatewayTimeoutError as ListPublicServicesGatewayTimeoutError } from "./types/ListPublicServices/ListPublicServicesError";
export const errors = {
    ListPublicServices: {
        InternalServerError: ListPublicServicesInternalServerError,
        BadGatewayError: ListPublicServicesBadGatewayError,
        GatewayTimeoutError: ListPublicServicesGatewayTimeoutError,
        GenericError: ListPublicServicesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListPublicServicesError: {
        InternalServerError: ListPublicServicesInternalServerError,
        BadGatewayError: ListPublicServicesBadGatewayError,
        GatewayTimeoutError: ListPublicServicesGatewayTimeoutError,
        GenericError: ListPublicServicesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InvalidSdkConfigurationError,
    InvalidRegionOrHostError,
    InvalidRegionError,
    InvalidHostError,
};
